import {callAPI} from "./apiWrapper";
import { getDeviceInfo } from '../lib/deviceInfo';


export const updateParticipantFromClient = async (queryParamas, landingURL) => {
    
    let allqueryParmas = queryParamas + "&landingURL=" + encodeURIComponent(landingURL);
    
    allqueryParmas = allqueryParmas + "&userStatus=2";
    
    // device information
    const deviceInfo = await getDeviceInfo();
    allqueryParmas = allqueryParmas + "&" + new URLSearchParams(deviceInfo).toString();

    return callAPI("GET", "updateParticipantFromClient/?", allqueryParmas, {}).then((result) => {
		  return result;
    });
}


